import jwt_decode from "jwt-decode";

import { getCurrentUserAttributes } from "../Api/Amplify";
import { getAnonymousToken } from "./anonymousTokenStorage";
import { deleteDOLToken, getDOLToken } from "./dolTokenStorage";

export const getEmailFromToken = async () => {
	const anonymousToken = getAnonymousToken();
	if (anonymousToken) {
		const { email } = jwt_decode(anonymousToken);
		return email;
	}

	const dolToken = getDOLToken();
	if (dolToken) {
		const { email } = jwt_decode(dolToken);
		return email;
	}

	const attributes = await getCurrentUserAttributes();
	if (attributes) {
		return attributes.email;
	}

	return undefined;
};

export const getSubFromToken = async () => {
	const attributes = await getCurrentUserAttributes();
	if (attributes) {
		return attributes.sub;
	}

	return undefined;
};
export const isAnonymousUser = () => !!getAnonymousToken();

const authErrorMessage = "Request failed with status code 403";

export const isAuthenticationError = error => {
	return (
		error.message === "UNAUTHORIZED" ||
		error.networkError?.result?.errors?.filter(e => e.message === authErrorMessage)
	);
};

export const getReceiptFromDolToken = () => {
	const dolToken = getDOLToken();
	if (dolToken) {
		const { receipt } = jwt_decode(dolToken);
		return receipt;
	}
};

export const isDOLUser = () => !!getDOLToken();

export const isDOLAuthenticated = searchParams => {
	const urlParams = new URLSearchParams(searchParams);
	const urlReceipt = urlParams.get("receiptNo");
	const key = urlParams.get("key");
	const hasURLReceipt = key && key.length === 20 && !urlParams.get("receiptNo");
	const tokenReceipt = getReceiptFromDolToken();
	if (tokenReceipt) {
		if (!hasURLReceipt || urlReceipt === tokenReceipt) {
			return true;
		} else {
			deleteDOLToken();
			return false;
		}
	}
	return false;
};
